import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue";
const _hoisted_1 = ["viewBox"];
const _hoisted_2 = ["r", "fill"];
const _hoisted_3 = ["r", "fill"];
const _hoisted_4 = ["r", "fill"];
const _hoisted_5 = ["r", "fill"];
const _hoisted_6 = ["font-size", "fill"];
const _hoisted_7 = ["d"];
const _hoisted_8 = {
  "dominant-baseline": "ideographic",
  transform: "rotate(180)",
  "text-anchor": "middle"
};
const _hoisted_9 = ["font-size", "fill"];
export default /*#__PURE__*/_defineComponent({
  __name: 'LogoCircle',
  props: {
    team: null,
    double: {
      type: Boolean
    },
    name: {
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    const size = ref(80);
    const sizeCircle = ref(15);
    const fontSize = computed(() => props.team.shortName.length > 3 ? 15 : 23);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "200",
        height: "200",
        viewBox: `-${size.value / 2} -${size.value / 2} ${size.value} ${size.value}`
      }, [_createElementVNode("circle", {
        r: size.value / 2,
        fill: __props.team.secondaryColor
      }, null, 8, _hoisted_2), __props.double ? (_openBlock(), _createElementBlock("circle", {
        key: 0,
        r: size.value / 2 - 4,
        fill: __props.team.primaryColor
      }, null, 8, _hoisted_3)) : _createCommentVNode("", true), __props.double ? (_openBlock(), _createElementBlock("circle", {
        key: 1,
        r: size.value / 2 - 8,
        fill: __props.team.secondaryColor
      }, null, 8, _hoisted_4)) : _createCommentVNode("", true), _createElementVNode("circle", {
        r: size.value / 2 - sizeCircle.value,
        fill: __props.team.primaryColor
      }, null, 8, _hoisted_5), _createElementVNode("text", {
        y: "3",
        "dominant-baseline": "middle",
        "text-anchor": "middle",
        "font-weight": "bold",
        "font-size": _unref(fontSize),
        fill: __props.team.secondaryColor
      }, _toDisplayString(__props.team.shortName), 9, _hoisted_6), __props.name ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [_createElementVNode("path", {
        id: "curve",
        d: `M -0 ${size.value / 2} A 1 1 -90 0 0 0 -${size.value / 2} A 1 1 -90 0 0 -0 ${size.value / 2}`,
        fill: "transparent"
      }, null, 8, _hoisted_7), _createElementVNode("text", _hoisted_8, [_createElementVNode("textPath", {
        "xlink:href": "#curve",
        "font-size": sizeCircle.value - 1,
        fill: __props.team.primaryColor,
        "font-weight": "bold",
        startOffset: "50%"
      }, _toDisplayString(__props.team.name), 9, _hoisted_9)])], 64)) : _createCommentVNode("", true)], 8, _hoisted_1);
    };
  }
});